import { RateRowDetailsProps } from "@/components/RateRowDetails/RateRowDetailsProps.ts";
import { useGetRPTranslated } from "@/helpers/translation/useGetRPTranslated.ts";
import DOMPurify from "dompurify";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

export const RateRowDetails = ({ ratePlan, showFullDescription = false }: RateRowDetailsProps) => {
  const { t } = useTranslation();
  const { description } = useGetRPTranslated(ratePlan);
  const descRef = useRef<HTMLDivElement>(null);
  const [isClamped, setIsClamped] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (showFullDescription || isExpanded) return;
    const el = descRef.current;
    if (el) {
      setIsClamped(el.scrollHeight > el.clientHeight);
    }
  }, [description, showFullDescription, isExpanded]);

  if (!description) return null;

  const isFull = showFullDescription || isExpanded;

  return (
    <div className="c-rate-row-details">
      <div
        ref={descRef}
        className={`c-rate-row-details__description${isFull ? " c-rate-row-details__description--full" : ""}${
          isClamped && !isFull ? " is-clamped" : ""
        }`}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
      />
      {isClamped && !showFullDescription && !isExpanded && (
        <button
          type="button"
          className="c-rate-row-details__details-link"
          onClick={(e) => {
            e.stopPropagation();
            setIsExpanded(true);
          }}
        >
          {t("expand")}
        </button>
      )}
    </div>
  );
};
